export default __webpack_public_path__ + "static/transaction-page-customer-0b7c919c8413966db6e1680783532066.png";